import React from "react";
import { authenticateUser } from "shared/auth";

const defaultAuthProps = {
  user: null,
  isUserSignedIn: false,
  isFetching: false,
};

const Auth = React.createContext(defaultAuthProps);

function provideAuth(Component) {
  return authenticateUser((props) => (
    <Auth.Provider value={props.auth}>
      <Component {...props} />
    </Auth.Provider>
  ));
}

function withAuth(Component) {
  return function AuthenticatedComponent(props) {
    return (
      <Auth.Consumer>
        {(auth) => <Component {...props} auth={auth} />}
      </Auth.Consumer>
    );
  };
}

export { provideAuth, withAuth };

export default Auth;
